<template>
  <div class="terms">
    <h3>1. Generelle betingelser:</h3>
    <p>Disse avtalevilkår erstatter tidligere vilkår og gjelder fra 15.11.2021. Vilkårene gjelder for privatkunder. Ved
      bestilling gir kunde Glitre Energi Strøm AS fullmakt til å:</p>
    <ul>
      <li>Melde leverandørbytte samt innhente nødvendige opplysninger fra nettselskapet.</li>
      <li>Melde ut- og innflytting på vegne av kunde til nettselskapet ved flytting. Ved flytting følger avtalen kunden
        til ny adresse.
      </li>
    </ul>
    <ol type="a">
      <li>Ved profilmålt anlegg må kunden levere oppdatert målerstand ved bestilling. Denne må ikke
        være eldre enn 3 måneder
        gammel.
      </li>
      <li>Glitre Energi Strøm har rett til å foreta kredittvurdering av kunder og kunne
        avslå/avslutte
        leveranse eller kreve garanti eller forskuddsbetaling fra kunder der det foreligger saklig grunn for det.
        Utsendelse av gjenpartsbrev vil foregå elektronisk på SMS/e-post/ Digipost der dette er praktisk mulig.
      </li>
    </ol>
    <h3>2. Samtykke</h3>
    <p>All kommunikasjon mellom Glitre Energi Strøm og kunde vil skje per e-post eller SMS, hvis ikke annet blir avtalt.
      Kunden vil motta informasjon, aktuelle nyheter og tilbud fra Glitre Energi Strøm og våre samarbeidspartnere basert
      på data lagret og sammenstilt på kunden. Dette vil sendes primært per e-post og SMS. Kunden kan når som helst
      trekke tilbake samtykket på Min Side. En avmelding vil ikke berøre informasjon som gjelder pris, forbruk, faktura
      eller annen viktig informasjon som gjelder kundeforholdet.</p>
    <h3>3. Leveringsvilkår</h3>
    <p>Leveringsvilkår for avtaleforholdet mellom kunden og Glitre Energi Strøm gjelder:</p>
    <ul>
      <li>Kundens bestilling</li>
      <li><a href="https://www.forbrukertilsynet.no/lov-og-rett/standardkontrakter/standard-kraftleveringsavtale"
             target="_blank">Energi Norges standardavtale for kraftleveranse</a> av 01.01.2017, utarbeidet i samarbeid
        med Forbrukerrådet og Forbrukertilsynet
      </li>
      <li>Følgende særvilkår av 15.11.2021, som kommer i tillegg til, eller erstatter deler av Standard
        Kraftleveringsavtale:
        <ol type="a">
          <li>Kraftleveranse fra Glitre Energi Strøm starter vanligvis innen 2 uker etter inngått avtale.</li>
          <li>I de tilfeller der kunden har angrerett gir kunden Glitre Energi Strøm anledning til å starte leveransen
            før angrefristens utløp. Dersom kunden likevel vil benytte angreretten må kunden betale for strømmen som
            blir levert fram til leveransen er avsluttet.
          </li>
          <li>Strømavtalene beskrevet i det følgende er forbeholdt privatkunder og mindre næringskunder (&lt;100 000
            kWh/år).
          </li>
          <li>Det tas forbehold om prisendringer som følge av endringer i dagens offentlige avgifter/pålegg, samt
            endringer i øvrige rammebetingelser og annen strømsalgsvirksomhet i sluttbrukermarkedet.
          </li>
          <li>Priser oppgis inklusive merverdiavgift og elsertifikat.</li>
          <li>Glitre Energi Strøm kan endre priselementene og avtalevilkårene med 14 dagers varsel. Informasjon om
            endringer gis direkte på SMS og e-post og på <a href="http://www.glitreenergi.no" target="_blank">www.glitreenergi.no</a>. (Dette
            punktet gjelder ikke dersom det er inngått avtale om fastpris for en nærmere avtalt tidsperiode).
          </li>
        </ol>
      </li>
    </ul>
    <h3>4. Betalingsvilkår</h3>
    <ol type="a">
      <li>Glitre Energi Strøm gjennomfakturer nettleie i utvalgte nettområder. Ved gjennomfakturering mottar kunden én
        faktura som inneholder både kraft og nettleie.
      </li>
      <li>Glitre Energi Strøm fakturerer som hovedregel etterskuddsvis hver måned basert på reelt eller estimert forbruk
        for kunden.
      </li>
      <li>For kunder som mottar papirfaktura vil det tilkomme et fakturagebyr etter de til enhver tid gjeldene satser.
      </li>
      <li>Kunden kan dele opp fakturaen evt. utsette forfallsdato. Dette gjøres på Min Side eller ved å kontakte
        kundesenteret.
      </li>
    </ol>
    <h3>5. «Glitre Familie / Glitre eSpot»</h3>
    <ol type="a">
      <li>Dersom netteier leverer timesverdier vil kunder med timesmåler bli avregnet etter eget forbruk time for time
        og etter priser på kraftbørsen Nord Pool. Prisen inkluderer elsertifikater og øvrige innkjøpskostnader i aktuelt
        leveringsområde. Denne avtalen har et påslag pr. kWh og et månedlig fastbeløp som følger de til enhver tid
        gjeldene satser.
      </li>
      <li>Kunder med profilmålt anlegg blir avregnet etter et forbruksveid gjennomsnitt for timesprisene på kraftbørsen
        Nord Pool.
      </li>
      <li>For brudd på avtaler inngått med rabatt og/eller bindingstid vil kunden faktureres for forbruk i
        leveringsperiode + bruddgebyr på max kr. 1000,- som erstatning for Glitre Energi Strøm sitt økonomiske tap, som
        følge av brudd på tidligere inngått avtale/bindingstid. Beløpet halveres dersom mindre enn halvparten av
        bindingstiden gjenstår.
      </li>
      <li>Avtalen løper til en av avtalepartene sier den opp.</li>
      <li><u>Glitre Energi Strøm kan endre priselementene og avtalevilkårene med 6 måneders varsel.</u> Informasjon om
        endringer gis direkte på SMS, e-post og på <a href="http://www.glitreenergi.no" target="_blank">www.glitreenergi.no.</a>
      </li>
    </ol>
    <h3>6. Angrefrist</h3>
    <p>Du har 14 dagers ubetinget angrerett etter bestilling av strømprodukt hos Glitre Energi Strøm. Angreskjema sendes
      ut ved registrering av et kundeforhold. Link til angrerettskjema: <a
          href="https://www.glitreenergi.no/strom/wp-content/uploads/2020/11/Angrerettskjema-nytt.pdf"
          target="_blank">https://www.glitreenergi.no/strom/wp content/uploads/2020/11/Angrerettskjema-nytt.pdf</a>
    </p>
  </div>
</template>

<script>
export default {
  name: "glitre"
}
</script>

<style scoped>
</style>
